import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { UploadLogoPayload } from './types';

import { QueryKeys } from '../keys';
import { request } from '../request';

export const useUpdateBrandLogo = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: UploadLogoPayload) => {
      await request(`/brands/${id}/logo`, { method: 'POST', body });
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QueryKeys.user }),
  });
};
